function handleContainer(removedClass, shownClass, container) {
  if (container !== null) {
    container.classList.remove(removedClass);
    container.classList.add(shownClass);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const showButton = document.querySelector(".installmentsTrigger");
  const installments = document.querySelector(".installmentsContainer");
  const background = document.querySelector(".backgroundDiv");

  if (showButton !== null) {
    showButton.addEventListener("click", () => {
      handleContainer("hiddenContainer", "shownContainer", installments);
      handleContainer("hiddenDiv", "shownDiv", background);
    });
  }

  if (installments !== null) {
    const closeModalButton = installments.querySelector(
      ".closeInstallmentsModal"
    );

    const paymentButtons = installments.querySelectorAll(".paymentType");

    if (closeModalButton !== null && background !== null) {
      [closeModalButton, background].forEach((elem) => {
        elem.addEventListener("click", () => {
          handleContainer("shownContainer", "hiddenContainer", installments);
          handleContainer("shownDiv", "hiddenDiv", background);
        });
      });
    }

    if (paymentButtons.length !== 0) {
      const tabs = installments.querySelectorAll(".tab");
      paymentButtons.forEach((button) => {
        button.addEventListener("click", () => {
          paymentButtons.forEach((button) => {
            handleContainer("filled", "notFilled", button.querySelector('svg'));
          });
          handleContainer("notFilled", "filled", button.querySelector('svg'));

          const dataIndex = button.getAttribute("data-index");

          tabs.forEach((tab) => {
            const tabIndex = tab.getAttribute("data-index");

            if (tabIndex === dataIndex) {
              handleContainer("hiddenContainer", "shownContainer", tab);
            } else {
              handleContainer("shownContainer", "hiddenContainer", tab);
            }
          });
        });
      });
    }
  }
});
